import { render } from "./Brand.vue?vue&type=template&id=79789bc8&scoped=true&ts=true"
import script from "./Brand.vue?vue&type=script&lang=ts"
export * from "./Brand.vue?vue&type=script&lang=ts"

import "./Brand.vue?vue&type=style&index=0&id=79789bc8&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79789bc8"]])

export default __exports__